import { useMediaQuery } from "@mui/material";
import styled from "styled-components";
import { useDataLayerContext } from "./ContextLayer/DataProvider/DataProvider";

const RightPanelAtom = styled.div<{$ready: boolean}>`
    max-width: 500px;
    width: 0px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;

    transition: width 300ms ease-in-out;

    @media screen and (orientation: landscape) and (min-width: 1200px) {
        & {
            width: ${props => props.$ready ? '450px' : '0px'};
            max-width: 600px;
        }
    }
` 

const FixedContainerAtom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 10px;
    padding: 10px 10px 10px 0px;
    min-width: 450px;
    max-width: 550px;
    height: 100%;
    box-sizing: border-box;
`

export default function RightPanel({ children }: { children: React.ReactNode }) {
    const isWideScreen = useMediaQuery('screen and (orientation: landscape) and (min-width: 1200px)');
    const { dataLayer } = useDataLayerContext();

    return (
        <RightPanelAtom $ready={dataLayer.ready}>
            <FixedContainerAtom>
                {isWideScreen ? children : null}
            </FixedContainerAtom>
        </RightPanelAtom>
    );
}